import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link as Link2 } from "react-router-dom";
import CountUp from "react-countup";

import About from "../assets/images/about.jpg";
import Map from "../assets/images/map.png";
import Service01 from "../assets/images/service/01.jpg";
import Service02 from "../assets/images/service/02.jpg";
import Service03 from "../assets/images/service/03.jpg";
import Service04 from "../assets/images/service/04.jpg";
import Service05 from "../assets/images/service/05.jpg";
import Service06 from "../assets/images/service/06.jpg";

export default function Services() {
  const [selectedService, setSelectedService] = useState("Applied AI-ML");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [showScrollUp, setShowScrollUp] = useState(false);

  // Handle scroll event to show/hide scroll up button
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const serviceSection = document.getElementById("service");
      if (serviceSection) {
        const serviceSectionTop = serviceSection.offsetTop;
        setShowScrollUp(scrollY > serviceSectionTop + 300);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToServices = () => {
    const serviceSection = document.getElementById("home");
    if (serviceSection) {
      serviceSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const serviceDetails = {
    "Applied AI-ML": {
      title: "Applied AI-ML",
      icon: "mdi mdi-matrix",
      image: Service01,
      description:
        "Leverage NuMantra's Applied AI practice to tackle your most pressing business challenges with targeted, outcome-driven solutions. Our AI-ML expertise spans across various industries and use cases.",
      features: [
        "Problem-Centric AI Consulting & ROI Alignment - High-impact opportunity identification through workshops mapping strategic priorities and pain points across industries. Quantify expected financial benefits—cost savings, revenue lift, or efficiency gains—before you invest. Outcome-based engagements with well-defined success metrics and business cases.",
        "GenAI Chatbots & Intelligent Automation - GenAI-powered chatbots and virtual assistants for natural language data queries (lab results, supply-chain KPIs, customer records). Automate routine workflows—contract review, invoice processing, compliance checks—using LLMs and RPA orchestration. Seamless integration into existing portals (Salesforce, SAP Fiori, intranets) with role-based security and audit trails.",
        "Agentic AI Application Design & Operating Model Re-Engineering - Value-chain mapping to identify 'bots-as-agents' for demand forecasting, quality-control alerts, and dynamic pricing. Prioritize use cases based on impact, feasibility, and data readiness. Redesign organizational processes to orchestrate humans and AI-agents in collaborative workflows, with governance and change management for adoption.",
        "Data Readiness & Value Pool Identification - Pragmatic data assessment framework to audit and score datasets on completeness, quality, and timeliness. Pinpoint data domains (e.g., R&D assay results, supplier performance logs, customer interaction histories) that unlock new efficiencies and growth. Prioritized action plans to ingest, clean, govern, and accelerate data pipelines for AI use cases.",
        "Industry-tailored expertise in regulated industries ensures practical, compliant, and impactful AI solutions",
        "End-to-end delivery: from ideation and data readiness through model build, operating model redesign, and managed rollout",
        "Time-bound, cost-committed: clear scoping, sprint-based delivery, and ROI guarantees",
        "Collaborative human-AI ecosystems: embedding AI into your organization for seamless human-AI collaboration",
      ],
    },
    "Data Engineering": {
      title: "Data Engineering",
      icon: "mdi mdi-database",
      image: Service02,
      description:
        "We bring advanced data services to navigate and build across the entire data value chain to source, process and store heterogeneous and complex data sets.",
      features: [
        "Data Integration - Integrate data across multiple domains and systems such as SAP, SFDC, Veeva, Oracle, SCM systems, and more.",
        "Data Storage - Custom data lakes for complex data sets, including medical images, device data, customer journey data, and social data.",
        "Data Processing - Business logic-driven data processing tailored to your requirements.",
        "Data Quality - Certify data completeness and quality so business users can trust the data they use.",
        "Common Data Models - Establish a single consumption layer for business users and applications, creating one version of enterprise truth.",
        "Data Governance - Ensure proper ownership, change control, lineage, and ongoing monitoring of data quality and usage parameters.",
      ],
    },
    "Cloud Engineering": {
      title: "Cloud Engineering",
      icon: "mdi mdi-cloud",
      image: Service05,
      description:
        "We help you architect and roadmap complex cloud scenarios as per your IT policies. We have successfully migrated and deployed across Amazon, Azure and Google cloud environments.",
      features: [
        "Cloud Strategy, Architecture & Roadmapping - IT-Policy Aligned Blueprint: Develop target-state architectures (AWS, Azure, GCP) that respect your governance, security, and cost-control policies. Roadmap Definition: Phased migration and modernization plan, including workload prioritization, inter-region traffic flows, and disaster-recovery zones. Cost & Performance Modeling: TCO analysis, sizing exercises, and performance benchmarks for core workloads (SAP, SFDC, custom apps).",
        "Multi-Cloud & Hybrid Architecture Design - Reference Architectures: Hardened patterns for single-vendor and multi-cloud deployments, including transit-gateway networks, VPC peering, and service mesh. Integration Fabric: Design of API gateways, secure connectivity (VPN, Direct Connect, ExpressRoute), and identity federation across clouds. Data-Services Blueprint: High-throughput data ingestion and storage (e.g., S3/Blob Storage/GCS, Data Lakes, Data Warehouses) for historical SAP and SFDC datasets.",
        "Enterprise Application Migration & Deployment - End-to-End Lift & Shift / Refactor: Hands-on migration of SAP modules, Salesforce environments, and legacy databases into cloud-native or containerized platforms. Data Migration Factory: Bulk-load design, parallel extract-transform-load pipelines and CDC (change data capture) for 'years worth' of transactional and master data. Cutover & Rollback Playbooks: Zero-downtime strategies, automated smoke tests, and fail-safe rollback procedures to guarantee business continuity.",
        "Cloud Security, Compliance & Governance - Secure Baseline Implementation: Automated enforcement of guardrails (CIS benchmarks, Azure Policy, AWS Config Rules, GCP Organization Policy). Identity & Access Management: Centralized IAM/IAG design with fine-grained roles for SAP admins, SFDC power users, and data engineers. Continuous Compliance: Automated compliance scanning, encryption-at-rest/key-management (KMS/Key Vault) and audit trail integration.",
        "DevOps, Automation & Managed Services - Infrastructure as Code: Terraform, ARM/Bicep, Cloud Deployment Manager templates with modular, reusable modules for rapid spin-up of environments. CI/CD Pipelines: Jenkins/GitHub Actions/Azure DevOps pipelines for application builds, automated testing, and blue-green cloud deployments. 24×7 Managed Cloud Operations: Proactive monitoring (CloudWatch, Azure Monitor, Stackdriver), incident response, patch management, and cost-optimization reviews.",
        "Analytics-Ready Data Platforms - Cloud Data Lakes & Warehouses: Landing zones, ETL orchestration (Glue, Data Factory, Dataflow), and Snowflake/Redshift/BigQuery deployments. Data Governance & Lineage: Cataloging, metadata management, and role-based access for SAP master data, SFDC customer records, and historical archives.",
      ],
    },
    "Enterprise Applications": {
      title: "Enterprise Applications",
      icon: "mdi mdi-code-tags",
      image: Service03,
      description:
        "Leverage our deep expertise across SAP HANA, Salesforce (SFDC), Oracle, and other top-tier enterprise suites to migrate, re-implement, or operate & evolve your mission-critical applications.",
      features: [
        "Strategic Application Migration & Re-Implementation - Assessment & Roadmap: Use our IT Transparency Tool to inventory and benchmark your application landscape by maturity, usage, and business impact. Define phased migration or greenfield re-implementation plans aligned to business priorities and risk profiles. Execution Excellence: Proven methodologies for 'lift & shift' moves to SAP HANA or Oracle Cloud, or ground-up SFDC re-rollouts. Automated data migration pipelines, cutover playbooks, and zero-downtime strategies. Cost & Risk Management: Fixed-price engagement models, continuous tracking of scoping, and proactive risk dashboards to keep budget and timeline on target.",
        "Managed Application Operations & Evolution - Run & Operate: 24×7 production support, release management, and batch monitoring for SAP, SFDC, and Oracle environments. SLA-driven incident resolution and performance tuning. Continuous Enhancement: Roadmaps for feature upgrades, UX modernizations, and process automations. Regular maturity and usage re-assessments via our benchmarking database to identify optimization opportunities.",
        "Fit-for-Future IT Architecture & Integration - Lightweight, Modular Design: Micro-services and API-first integration patterns that decouple core ERP/CRM from ancillary services. Simplified data flows—ensuring your SAP HANA data lake, Salesforce data cloud, and Oracle transactional systems work seamlessly together. Scalability & Extensibility: Leverage containerization (Kubernetes, Docker) and event-driven platforms to add new capabilities (IoT, AI/ML, analytics) without disrupting core systems. Governance & Transparency: Our proprietary tool maintains a live catalog of systems and interfaces, with health, usage, and impact metrics—enabling real-time governance and change-impact analysis.",
        "Value-Driven Innovation & Optimization - Process Re-Engineering: Align ERP/CRM capabilities to future business processes—introducing lean workflows, embedded analytics, and decision-support accelerators. Benchmark-Led Performance: Continuous benchmarking against industry peers to drive cost efficiencies, performance gains, and license rationalization.",
        "End-to-End Ownership: From discovery (via our transparency tool) through migration, operation, and evolution.",
        "Benchmark-Backed Decisions: Data-driven insights into which applications to invest in, retire, or modernize.",
        "Cost Discipline: Fixed-scope pilots, transparent tracking, and proactive risk mitigation ensure no surprises.",
        "Future-Ready by Design: Architectures built for modular growth, global scale, and integration with next-gen technologies.",
      ],
    },
    "Bespoke Applications": {
      title: "Bespoke Applications",
      icon: "mdi mdi-code-braces",
      image: Service04,
      description:
        "Driven by our passion for rapidly deployable, cloud-native software, NuMantra's in-house R&D in Europe has built HCare360—a hyper-automation platform.",
      features: [
        "Rapid Prototyping & MVP Delivery - Pilot in ≤ 4 Weeks: Early proof-of-concept to validate requirements and user experience. MVP in ≤ 4 Months: Fully functional minimum-viable product with core features and integrations.",
        "Cloud-Native, Globally Scalable Architecture - Containerized Microservices: Deploy on AWS, Azure, or GCP with auto-scaling and high availability. Multi-Region Support: Globally distributed deployments to meet latency and resiliency needs.",
        "Regulatory & Data-Privacy Compliance - Heterogeneous Jurisdiction Support: Built-in controls for GDPR, HIPAA, Swiss FADP, and other local regulations. Data Segmentation & Masking: Dynamic anonymization and pseudonymization for sensitive datasets.",
        "Enterprise-Grade Security & Access Control - Zero-Trust Identity Framework: Role-based access, single sign-on (SSO), and multi-factor authentication (MFA). End-to-End Encryption: TLS everywhere plus at-rest encryption with customer-managed keys.",
        "Seamless Systems & IoT Integrations - API-First Design: Rapid connectors for SAP, Salesforce, EHR platforms, and custom databases. IoT & Telemetry Ingestion: Real-time device data pipelines (MQTT, OPC-UA, HTTP) for dashboards and analytics.",
        "Speed & Predictability: Fixed-timeline pilots and MVPs let you de-risk innovation.",
        "Future-Proofed Platform: Grow from a single department to global roll-outs without re-architecture.",
        "Compliance-by-Design: Your data governance and audit requirements are baked into every release.",
        "Enterprise Reliability: Proven track record in EMEA, Americas, and APAC for mission-critical applications.",
      ],
    },
    Visualization: {
      title: "Data Visualization",
      icon: "mdi mdi-chart-bar",
      image: Service06,
      description:
        "We bring expertise in turning numbers into stories and insights that can guide the leadership and operating teams to review performance and explore improvement opportunities.",
      features: [
        "Visualization Strategy & Dashboard Design - Assess business KPIs, user personas, and reporting needs. Prototype wireframes & storyboards for executive, operational, and analytical dashboards. Technology examples: Microsoft Power BI, Tableau, Qlik Sense, Google Looker.",
        "End-to-End Dashboard Development & Deployment - Connect to disparate data sources (e.g., SQL/Redshift, Snowflake, Azure Data Lake). Build interactive visuals, drill-downs, and parameterized reports. Automate data refresh and schedule report distribution. Technology examples: Power BI Service & Embedded, Tableau Server/Online, Qlik Cloud.",
        "Advanced Analytics & Embedded Visualizations - Integrate AI/ML insights: predictive forecasts, clustering heatmaps, anomaly detection visuals. Embed interactive charts into web/mobile apps or third-party portals. Technology examples: Power BI Embedded, Tableau Embedded Analytics, D3.js, Plotly.",
        "Governance, Performance Tuning & UX Optimization - Define naming conventions, version control, and access permissions (Row-Level Security). Optimize queries, data models, and dashboard rendering for large-scale deployments. Conduct usability testing and iterate on color palettes, layouts, and accessibility. Technology examples: Power BI Premium (Capacity), Tableau Governance Tools, Qlik Sense Monitoring.",
        "Training, Adoption & Managed Services - Hands-on workshops, 'train-the-trainer' programs, and self-service analytics enablement. Ongoing dashboard support, enhancement sprints, and health-checks. Usage analytics to drive continuous improvement in adoption and ROI. Technology examples: Power BI Learning Paths, Tableau eLearning, Qlik Continuous Classroom.",
      ],
    },
  };

  const handleServiceClick = (serviceKey) => {
    setModalData({
      title: serviceDetails[serviceKey].title,
      image: serviceDetails[serviceKey].image,
      sections: [
        {
          heading: serviceDetails[serviceKey].title,
          content: serviceDetails[serviceKey].description,
        },
        { heading: "Features", content: serviceDetails[serviceKey].features },
      ],
    });
    setModalOpen(true);

    // Scroll to the details section after a short delay to ensure state updates
    setTimeout(() => {
      const detailsSection = document.getElementById("service-details");
      if (detailsSection) {
        detailsSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 100);
  };

  const currentService = serviceDetails[selectedService];

  return (
    <section className="section bg-light" id="service">
      <style>
        {`
          .features.active {
            background-color: #f8f9fa;
            border-left: 4px solid #007bff;
            padding-left: 15px;
            transition: all 0.3s ease;
          }
          .features:hover {
            background-color: #f8f9fa;
            cursor: pointer;
          }
        `}
      </style>
      <Container>
        <div className="row justify-content-center">
          <Col lg={12}>
            <div className="features-absolute rounded shadow px-4 py-5 bg-white">
              <div className="section-title text-center mb-4 pb-2">
                <h4 className="title mb-3">Our Services</h4>
                <p className="text-muted mx-auto para-desc mb-0">
                  We bring precise skills with in- depth experience.
                </p>
              </div>
              <Row>
                {Object.keys(serviceDetails).map((key) => (
                  <div
                    key={key}
                    className={`col-lg-4 col-md-6 mt-4 pt-4${
                      selectedService === key ? " active" : ""
                    }`}
                  >
                    <div
                      className={`d-flex features feature-primary p-4${
                        selectedService === key ? " active" : ""
                      }`}
                      onClick={() => {
                        setSelectedService(key);
                        handleServiceClick(key);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="feature-icon text-center">
                        <i
                          className={`${serviceDetails[key].icon} rounded h4`}
                        ></i>
                      </div>
                      <div className="flex-1 ms-3">
                        <h5 className="mt-0">{serviceDetails[key].title}</h5>
                        <p className="text-muted mb-0">
                          {serviceDetails[key].description.substring(0, 80)}...
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </Row>
            </div>
          </Col>
        </div>
      </Container>

      <div className="container mt-100 mt-60">
        <div style={{ background: `url(${Map}) center center` }}>
          <div className="row" id="service-details">
            {/* First Row: Image and Text */}
            <div className="col-lg-6 col-md-6">
              <div className="position-relative me-lg-5">
                <img
                  src={currentService.image}
                  className="rounded img-fluid mx-auto d-block"
                  alt={currentService.title}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
              <div className="section-title">
                <h4 className="title mb-3">{currentService.title}</h4>
                <p className="text-muted">{currentService.description}</p>
              </div>
            </div>
          </div>

          {/* Second Row: Full-width Text */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="section-title">
                <ul className="list-unstyled text-muted">
                  {currentService.features.map((feature, index) => (
                    <li className="mb-3" key={index}>
                      <span className="text-numantra-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      {feature}
                    </li>
                  ))}
                </ul>

                <div className="d-inline-block">
                  <div className="pt-3 d-flex align-items-center border-top">
                    <i className="uil uil-envelope me-2 fs-1"></i>
                    <div className="content">
                      <p className="mb-0">Need More Help?</p>
                      <Link2
                        to="#contact"
                        className="text-dark h6"
                        onClick={(e) => {
                          e.preventDefault();
                          const contactSection =
                            document.getElementById("contact");
                          if (contactSection) {
                            contactSection.scrollIntoView({
                              behavior: "smooth",
                              block: "start",
                            });
                          }
                        }}
                      >
                        Ask us your question
                      </Link2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-5">
        <Row>
          <div className="col-md-6 col-6">
            <div className="counter-box position-relative text-center">
              <h3 className="mb-0 fw-semibold mt-2">
                <CountUp
                  className="counter-value"
                  start={3}
                  end={65}
                  delay={2}
                />
                %{" "}
              </h3>
              <span className="counter-head text-muted">Time to Results</span>
            </div>
          </div>

          <div className="col-md-6 col-6">
            <div className="counter-box position-relative text-center">
              <h3 className="mb-0 fw-semibold mt-2">
                <CountUp
                  className="counter-value"
                  start={1}
                  end={60}
                  delay={2}
                />
                %{" "}
              </h3>
              <span className="counter-head text-muted">Cost of Ownership</span>
            </div>
          </div>

          {/* <div className="col-md-3 col-6">
            <div className="counter-box position-relative text-center">
              <h3 className="mb-0 fw-semibold mt-2">
                <CountUp
                  className="counter-value"
                  start={200}
                  end={457}
                  delay={2}
                />
                K{" "}
              </h3>
              <span className="counter-head text-muted">Members</span>
            </div>
          </div> */}

          {/* <div className="col-md-3 col-6">
            <div className="counter-box position-relative text-center">
              <h3 className="mb-0 fw-semibold mt-2">
                <CountUp
                  className="counter-value"
                  start={100}
                  end={150}
                  delay={2}
                />
                +{" "}
              </h3>
              <span className="counter-head text-muted">Employee</span>
            </div>
          </div> */}
        </Row>
      </div>

      {/* Scroll Up Button */}
      {showScrollUp && (
        <button
          onClick={scrollToServices}
          className="scroll-up-btn"
          title="Scroll to Services"
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            cursor: "pointer",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            boxShadow: "0 4px 12px rgba(0, 123, 255, 0.3)",
            transition: "all 0.3s ease",
            animation: "fadeInUp 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#0056b3";
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 6px 16px rgba(0, 123, 255, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#007bff";
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 4px 12px rgba(0, 123, 255, 0.3)";
          }}
        >
          <i className="mdi mdi-arrow-up"></i>
        </button>
      )}

      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          .scroll-up-btn:hover {
            background-color: #0056b3 !important;
          }
        `}
      </style>
    </section>
  );
}
